export default {
  title: 'Ce părere ai despre {{name}}?',
  description: 'Feedback-ul tău este anonim și ne ajută să ne îmbunătățim.',
  upload_google_review: {
    title: 'Recenzează-ne și câștigă recompense',
  },
};
